import { memo } from 'react';
import classNames from 'classnames';

import { currencyReplacer } from '@mentalgrowth/web_utils';
import { useFeature } from '@features/FeatureToggle';

import styles from './CardAnnotation.module.scss';

const PLAN_NAMES = [
  '1-WEEK TRIAL',
  '1-MONTH PLAN',
  '4-WEEK PLAN',
  '3-MONTH PLAN',
] as const;

type PlanNameType = (typeof PLAN_NAMES)[number];

type CardAnnotationProps = {
  currency: string;
  fullPriceDiscount: number | null;
  planName: string;
};

export const CardAnnotation = memo((props: CardAnnotationProps) => {
  const { currency, fullPriceDiscount, planName } = props;
  const isComboPaywallEnabled = useFeature('comboPaywall');

  const currencySign = currencyReplacer(currency);

  const comboPaywallAnnotations = {
    '1-WEEK TRIAL': `Without cancellation, before the 7-day trial ends, I accept that it will convert to a 1-month subscription and automatically charge ${currencySign}${fullPriceDiscount} (incl. VAT) every 4 weeks until I cancel. You can cancel the subscription at any time at no additional cost by contacting support@mentalgrowth.app`,
    '1-MONTH PLAN': `Without cancellation, before the selected discounted intro plan ends, I accept that will automatically charge ${currencySign}${fullPriceDiscount} (incl. VAT) every 4 weeks until I cancel. You can cancel the subscription at any time at no additional cost by contacting support@mentalgrowth.app`,
    '4-WEEK PLAN': `Without cancellation, before the selected discounted intro plan ends, I accept that will automatically charge ${currencySign}${fullPriceDiscount} (incl. VAT) every 4 weeks until I cancel. You can cancel the subscription at any time at no additional cost by contacting support@mentalgrowth.app`,
    '3-MONTH PLAN': `Without cancellation, before the selected discounted intro plan ends, I accept that will automatically charge ${currencySign}${fullPriceDiscount} (incl. VAT) every 12 weeks until I cancel. You can cancel the subscription at any time at no additional cost by contacting support@mentalgrowth.app`,
  };

  const defaultText =
    planName === '4-WEEK PLAN'
      ? `Without cancellation, before the selected discounted intro plan ends, I accept that will automatically charge ${currencySign}${fullPriceDiscount} (incl. VAT) every 4 weeks until I cancel. You can cancel the subscription at any time at no additional cost by contacting support@mentalgrowth.app`
      : `Without cancellation, before the 7-day trial ends, I accept that it will convert to a 4-week subscription and automatically charge ${currencySign}${fullPriceDiscount} (incl. VAT) every 4 weeks until I cancel. You can cancel the subscription at any time at no additional cost by contacting support@mentalgrowth.app`;

  const renderText = isComboPaywallEnabled
    ? (comboPaywallAnnotations[planName as PlanNameType] ?? defaultText)
    : defaultText;

  return (
    <div
      className={classNames(styles.host, {
        [styles.comboVariant]: isComboPaywallEnabled,
      })}
    >
      {renderText}
    </div>
  );
});
